module.exports = __webpack_public_path__ + "img/downloads_ies-webcast.18cd8aa3.png";